module.exports = "https://www.gc-pro.gnp.com.mx/39f87756d59a22d190c05fa5362be468.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/arrow_forward_ios_24px_rounded.svg
// module id = 8062
// module chunks = 0